<script setup>
import { computed } from 'vue';

const showCopilotLauncher = computed(() => false);
</script>

<template>
  <div v-if="showCopilotLauncher" />
</template>
